<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                Nos partenaires
                <span>Des offres négociées avec les meilleurs professionnels de l’immobilier</span>
            </h1>
        </div>
    </div>

    <div class="row mb-4">
        <div class="col-lg-3 col-md-7 col-6 pe-0">
            <mat-form-field class="no-label">
                <mat-select [(ngModel)]="currentCategories" disableOptionCentering
                            (ngModelChange)="filter()"
                            class="select-search"
                            placeholder="Catégorie">
                    <mat-option value="">Tous nos partenaires</mat-option>
                    <mat-option *ngFor="let categorie of categories;"
                                value="{{ categorie }}">
                        {{ categorie }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row mt-lg-3 mb-lg-3 mt-5">
        <mat-spinner color="second" [hidden]="!loading"></mat-spinner>
        <div *ngFor="let partner of partners" class="partner">
            <div class="card">
                <img src="{{ partner.logo }}" alt="{{ partner.title }}"/>
                <h3>{{ partner.title }}</h3>
                <p class="categorie {{partner.categorie.replace(' ', '') | lowercase }}">{{ partner.categorie }}</p>
                <b class="subtitle">{{ partner.sub_title }}</b>
                <p [innerHTML]="partner.description | nl2br"></p>
                <b class="profit">{{ partner.offers }}</b>
                <button type="button" (click)="openDetail(partner)" class="btn btn-primary w-100">
                    Détails
                </button>
            </div>
        </div>
    </div>
</div>
